import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const { state } = useLocation();
  const orderNumber = state?.orderNumber;
  const customerName = state?.firstName;
  const email = state?.email;
  const total = Number(state?.total);

  return (
    <main className="payment-success" id="main-content">
      <section className="payment-success__hero" aria-live="polite">
        <div className="payment-success__check" aria-hidden="true">
          <FiCheck />
        </div>
        <p className="payment-success__eyebrow">Thank you{customerName ? `, ${customerName}` : ""}</p>
        <h1>{orderNumber ? "Your order is confirmed." : "Thank you for your order."}</h1>
        <p className="payment-success__intro">
          {email
            ? `A confirmation has been sent to ${email}.`
            : "Your confirmation email contains the latest order details."}
          {" "}We’ll let you know as soon as your parcel leaves our Hong Kong studio.
        </p>

        <div className="payment-success__reference">
          <div>
            <span>Order reference</span>
            <strong>{orderNumber || "Available in your confirmation email"}</strong>
          </div>
          {Number.isFinite(total) && total > 0 && (
            <div>
              <span>Order total</span>
              <strong>{formatPrice(total)}</strong>
            </div>
          )}
        </div>

        <div className="payment-success__actions">
          <Link className="payment-success__primary" to="/shop">
            Continue shopping <FiArrowRight aria-hidden="true" />
          </Link>
          <Link to="/">Return home</Link>
        </div>
      </section>

      <section className="payment-success__next" aria-labelledby="what-next-title">
        <div>
          <p className="payment-success__eyebrow">What happens next</p>
          <h2 id="what-next-title">From our studio to your home.</h2>
        </div>
        <ol>
          <li>
            <span>01</span>
            <div>
              <h3>Order review</h3>
              <p>We confirm your details and reserve every object in your order.</p>
            </div>
          </li>
          <li>
            <span>02</span>
            <div>
              <h3>Careful packing</h3>
              <p>Your parcel is prepared within {siteConfig.shipping.dispatchDays}.</p>
            </div>
          </li>
          <li>
            <span>03</span>
            <div>
              <h3>Tracking</h3>
              <p>We send a tracking link when your selected objects are on the way.</p>
            </div>
          </li>
        </ol>
        <p className="payment-success__support">
          Need help? Email{" "}
          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
          .
        </p>
      </section>
    </main>
  );
};

export default PaySuccess;
